<template>
    <ul
        class="pagination"
        :class="[size && `pagination-${size}`]">
        <li
            class="page-item prev-page"
            :class="{disabled: modelValue === 1, 'iframe-style': iframe}">
            <a
                class="page-link pointer"
                aria-label="Previous"
                @click="prevPage">
                <span aria-hidden="true"><font-awesome-icon icon="chevron-left" /></span>
            </a>
        </li>
        <li
            v-show="1 < minPage"
            class="page-item"
            :class="{active: modelValue === 1, 'iframe-style': iframe}">
            <a
                v-if="modelValue === 1"
                class="page-link">1</a>
            <a
                v-else
                class="page-link pointer"
                @click="changePage(1)">1</a>
        </li>
        <li
            v-show="minPage > (1 + 1)"
            class="page-item disabled">
            <a class="page-link">...</a>
        </li>
        <li
            v-for="item in range(minPage, maxPage)"
            :key="item"
            class="page-item"
            :class="{active: modelValue === item, 'iframe-style': iframe}">
            <a
                v-if="modelValue === item"
                class="page-link">{{ item }}</a>
            <a
                v-else
                class="page-link pointer"
                @click="changePage(item)">{{ item }}</a>
        </li>
        <li
            v-show="maxPage < (totalPages - 1)"
            class="page-item disabled">
            <a class="page-link">...</a>
        </li>
        <li
            v-show="totalPages > maxPage"
            class="page-item"
            :class="{active: modelValue === totalPages, 'iframe-style': iframe}">
            <a
                v-if="modelValue === totalPages"
                class="page-link">{{ totalPages }}</a>
            <a
                v-else
                class="page-link pointer"
                @click="changePage(totalPages)">{{ totalPages }}</a>
        </li>
        <li
            class="page-item next-page"
            :class="{disabled: modelValue === totalPages, 'iframe-style': iframe}">
            <a
                class="page-link pointer"
                aria-label="Next"
                @click="nextPage">
                <span aria-hidden="true"><font-awesome-icon icon="chevron-right" /></span>
            </a>
        </li>
    </ul>
</template>
<script>
export default {
    name: "BasePagination",
    props: {
        pageCount: {
            type: Number,
            default: 0,
            description:
                "Pagination page count. This should be specified in combination with perPage"
        },
        perPage: {
            type: Number,
            default: 10,
            description:
                "Pagination per page. Should be specified with total or pageCount"
        },
        total: {
            type: Number,
            default: 0,
            description:
                "Can be specified instead of pageCount. The page count in this case will be total/perPage"
        },
        modelValue: {
            type: Number,
            default: 1,
            description: "Pagination modelValue"
        },
        size: {
            type: String,
            default: "",
            description: "Pagination size"
        },
        iframe: {
            type: Boolean,
            default: false,
            description: "Use iframe style pagination, see _pagination.scss in registration for more details"
        }
    },
    data() {
        return {
            defaultPagesToDisplay: 5
        };
    },
    computed: {
        totalPages() {
            if (this.pageCount > 0) return this.pageCount;
            if (this.total > 0) {
                return Math.ceil(this.total / this.perPage);
            }
            return 1;
        },
        pagesToDisplay() {
            if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
                return this.totalPages;
            }
            return this.defaultPagesToDisplay;
        },
        minPage() {
            if (this.modelValue >= this.pagesToDisplay) {
                const pagesToAdd = Math.floor(this.pagesToDisplay / 2);
                const newMaxPage = pagesToAdd + this.modelValue;
                if (newMaxPage > this.totalPages) {
                    return this.totalPages - this.pagesToDisplay + 1;
                }
                return this.modelValue - pagesToAdd;
            } else {
                return 1;
            }
        },
        maxPage() {
            if (this.modelValue >= this.pagesToDisplay) {
                const pagesToAdd = Math.floor(this.pagesToDisplay / 2);
                const newMaxPage = pagesToAdd + this.modelValue;
                if (newMaxPage < this.totalPages) {
                    return newMaxPage;
                } else {
                    return this.totalPages;
                }
            } else {
                return this.pagesToDisplay;
            }
        }
    },
    methods: {
        range(min, max) {
            const arr = [];
            for (let i = min; i <= max; i++) {
                arr.push(i);
            }
            return arr;
        },
        changePage(item) {
            this.$emit("update:modelValue", item);
        },
        nextPage() {
            if (this.modelValue < this.totalPages) {
                this.$emit("update:modelValue", this.modelValue + 1);
            }
        },
        prevPage() {
            if (this.modelValue > 1) {
                this.$emit("update:modelValue", this.modelValue - 1);
            }
        }
    },
    watch: {
        perPage() {
            this.$emit("update:modelValue", 1);
        },
        total() {
            this.$emit("update:modelValue", 1);
        }
    }
};
</script>

<style scoped>
  @media (max-width: 500px) {
    .pagination .page-item:not(.active, .next-page, .prev-page) {
      display: none;
    }
  }
  .page-item.active > .page-link{
      color: white;
      cursor: default;
  }
</style>
